export function registerMetaPixel(opts) {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
    (function (f, b, e, v) {
        const fw = f;
        if (fw.fbq)
            return;
        const n = function (...args) {
            const cm = n.callMethod;
            if (cm) {
                cm(...args);
            }
            else {
                n.queue?.push(args);
            }
        };
        if (!fw._fbq)
            fw._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        s.parentNode?.insertBefore(t, s);
        fw.fbq = n;
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', opts.pixelId);
    // Tracking is enabled by owners only when consent category is granted
}
//# sourceMappingURL=meta.js.map